import jsonwebtoken from "jsonwebtoken";

const generate = (
  privateKey,
  {
    name = "Nurse",
    email = "",
    avatar = "",
    appId = process.env.REACT_APP_JITSI_APP_ID,
    kid = process.env.REACT_APP_JITSI_KID,
  },
) => {
  const now = new Date();
  const jwt = jsonwebtoken.sign(
    {
      aud: "jitsi",
      context: {
        user: {
          id: "nurse " + Math.random(),
          name,
          avatar,
          email: email,
          moderator: "true",
        },
        features: {
          livestreaming: "true",
          recording: "true",
          transcription: "true",
          "outbound-call": "true",
        },
      },
      iss: "chat",
      room: "*",
      sub: appId,
      exp: Math.round(now.setHours(now.getHours() + 8) / 1000),
      nbf: Math.round(new Date().getTime() / 1000) - 10,
    },
    privateKey,
    { algorithm: "RS256", header: { kid } },
  );
  localStorage.setItem("jaas_jwt", jwt);
  return jwt;
};

export default generate;
